import styled from "styled-components";

export const OpenPasswordResetIcon = styled.svg`
  width: 24px;
  height: 24px;
  stroke: #000;
`;

export const ClosePasswordResetIcon = styled.svg`
  width: 24px;
  height: 24px;
  stroke: #000;
`;
